<template>
  <div class="infinite-pagination pagination-progress-bar">
    <div>
      <button-fi
        v-if="paginationPage < paginationTotal && showMoreButton"
        :href="href"
        :class="{
          'pagination-progress-bar__button': true,
          'button-fi__tertiary': true,
        }"
        :disabled="disabledState"
        @click="loadMore"
      >
        {{
          showMoreButtonText ? showMoreButtonText : $dict.get('product-List.Pagination.Load-More')
        }}
      </button-fi>

      <div class="pagination-progress-bar__text">
        <slot> {{ paginationPage }} / {{ paginationTotal }} </slot>
      </div>
    </div>

    <div class="pagination-progress-bar__bar">
      <div
        class="pagination-progress-bar__bar-progress"
        :style="{ width: `${Math.min(progressbarValue, 100)}%` }"
      />
    </div>
  </div>
</template>

<script>
import ButtonFi from 'atoms/button-fi/ButtonFi.vue';
export default {
  name: 'PaginationProgressBar',
  components: {
    ButtonFi,
  },
  props: {
    queryParams: {
      type: String,
      default: null,
    },
    paginationPage: {
      type: Number,
      required: true,
    },
    paginationTotal: {
      type: Number,
      required: true,
    },
    progressbarValue: {
      type: Number,
      required: true,
    },
    disabledState: {
      type: Boolean,
      required: false,
      default: false,
    },
    showMoreButton: {
      type: Boolean,
      default: true,
    },
    showMoreButtonText: {
      type: String,
      default: null,
    },
  },
  emits: ['loadmore'],
  computed: {
    getPaginationButtonLink() {
      return this.paginationPage + 1;
    },
    href() {
      if (this.disabledState) {
        return null;
      }
      return `${this.queryParams ? this.queryParams + '&' : '?'}page=${
        this.getPaginationButtonLink
      }`;
    },
  },
  methods: {
    loadMore(evt) {
      if (this.$fischer.query('page')) {
        if (this.href) {
          window.location = this.href;
          evt.preventDefault();
        }
        return;
      }
      evt.preventDefault();
      this.$emit('loadmore', {});
    },
  },
};
</script>

<style scoped lang="scss">
@import './pagination-progress-bar';
</style>
